<template>
  <div
    class="mats-listing__wrapper"
    style="margin-top: -8px;"
    @click="removeLists"
  >
    <div class="filtering">
      <div class="search-toggle">

        <p>{{ $t('SearchBy') }}</p>
        <div>
          <p
            :class="{ active2: toggleSarch === 'CustomerName' }"
            @click="showCustomerName(), toggleSarch = 'CustomerName'"
          >
            {{ $t('CustomerName') }}
          </p>
          <p
            :class="{ active2: toggleSarch === 'OrderNumber' }"
            @click="showOrderNumber(), toggleSarch = 'OrderNumber'"
          >
            {{ $t('OrderNumber') }}
          </p>
          <p
            :class="{ active2: toggleSarch === 'ShippingNotes' }"
            @click="showShippingNotes(), toggleSarch = 'ShippingNotes'"
          >
            {{ $t('ShippingNotes') }}
          </p>
        </div>
      </div>
      <div v-if="toggleSarch === 'CustomerName'">
        <div>
          <div class="black">
            <b-icon-search
              v-if="searchCN == ''"
              class="search1"
              style="position: absolute; left: 5px; top: 12px"
            />
            <b-icon-x-circle
              v-else-if="searchCN != '' && !noSearch"
              class="search1"
              style="position: absolute; right: 20px; top: 12px; cursor: pointer"
              @click="searchCN = ''"
            />
            <input
              v-model="searchCN"
              type="text"
              autocomplete="off"
              name="search-box"
              :placeholder="$t('CustomerName')"
              :style="getFilteredOrdersbyCN.length > 0 && noSearchTwo ? 'border-radius: 8px 8px 0px 0px' : ''"
              @keyup="inputChanged1"
              @keydown.down="onArrowDown1"
              @keydown.up="onArrowUp1"
            >
          </div>
          <div
            v-if="getFilteredOrdersbyCN.length > 0 && noSearchTwo"
            ref="scrollContainer"
            class="dropdrop"
            style="
              display: inline-block;
              overflow: auto;
              position: absolute;
              background: white;
              width: 229px;
              box-shadow: none;
            "
            :style="getFilteredOrdersbyCN.length > 7 ? 'height: 210px' : 'height: auto'"
          >
            <div
              v-for="(result, index) in getFilteredOrdersbyCN"
              ref="options2"
              :key="index"
              :class="{ 'is-active': index === arrowCounter }"
              style="cursor: pointer"
              class="search-item"
              @click="searchByCn(result ); noSearchTwo = false"
            >
              <p style="margin: 0">
                {{ result.nameToDisplay }}
              </p>
            </div>
            <div
              v-if="getFilteredOrdersbyCN.length == 0"
              class="search-item"
            >
              <p>{{ $t('NoResult') }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="toggleSarch === 'OrderNumber'">
        <div class="black">
          <b-icon-search
            v-if="searchOrder == ''"
            class="search1"
            style=" position: absolute; left: 5px; top: 13px"
          />
          <b-icon-x-circle
            v-else-if="searchOrder != '' && !noSearch"
            class="search1"
            style="position: absolute; margin-top: -6px; right: 20px; top: 17px; cursor: pointer"
            @click="searchOrder = ''"
          />
          <input
            v-model="searchOrder"
            type="text"
            autocomplete="off"
            name="search-box"
            :placeholder="$t('OrderNumber')"
            :style="getFilteredOrdersbyON.length > 0 && noSearch ? 'border-radius: 8px 8px 8px 8px' : ''"
            @keyup="inputChanged"
            @keydown.down="onArrowDown"
            @keydown.up="onArrowUp"
          >
        </div>
        <div
          v-if="getFilteredOrdersbyON.length > 0 && noSearch"
          ref="scrollContainer"
          class="dropdrop"
          :style="getFilteredOrdersbyON.length > 7 ? 'height: 210px' : 'height: auto'"
        >
          <div
            v-for="(result, index) in getFilteredOrdersbyON"
            :key="index"
            ref="options"
            style="cursor: pointer"
            class="search-item"
            :class="{ 'is-active': index === arrowCounter }"
            @click="searchByOn(result); noSearch = false"
          >
            <p style="margin: 0">
              {{ result }}
            </p>
          </div>
          <!-- <div
            v-if="getFilteredOrdersbyON.length == 0"
            class="search-item"
          >
            <p>Sorry. No Results.</p>
          </div> -->
        </div>
      </div>
      <div v-if="toggleSarch === 'ShippingNotes'">
        <div class="black">
          <b-icon-search
            v-if="searchShip == ''"
            class="search1"
            style="position: absolute; left: 5px; top: 13px"
          />
          <b-icon-x-circle
            v-else-if="searchShip != '' && !noSearchThree"
            class="search1"
            style="position: absolute; margin-top: -6px; right: 20px; top: 17px; cursor: pointer"
            @click="searchShip = ''"
          />
          <input
            v-model="searchShip"
            type="text"
            autocomplete="off"
            name="search-box"
            :placeholder="$t('ShippingNotes')"
            :style="getFilteredOrdersByShipment.length > 0 && noSearchThree ? 'border-radius: 8px 8px 0px 0px' : ''"
            @keyup="inputChanged3"
            @keydown.down="onArrowDown3"
            @keydown.up="onArrowUp3"
          >
        </div>
        <div
          v-if="getFilteredOrdersByShipment.length > 0 && noSearchThree"
          ref="scrollContainer2"
          class="dropdrop"
          style="
              display: inline-block;
              overflow: auto;
              position: absolute;
              background: white;
              z-index: 423 !important;
              width: 229px;
              box-shadow: none;
            "
          :style="getFilteredOrdersByShipment.length > 7 ? 'height: 210px' : 'height: auto'"
        >
          <div
            v-for="(result, index) in getFilteredOrdersByShipment"
            ref="options2"
            :key="index"
            :class="{ 'is-active': index === arrowCounter3 }"
            style="cursor: pointer"
            class="search-item"
            @click="searchByShip(result); noSearchThree = false"
          >
            <p style="margin: 0">
              {{ result.notes }}
            </p>
          </div>
          <div
            v-if="getFilteredOrdersByShipment.length == 0"
            class="search-item"
          >
            <p>{{ $t('NoResult') }}</p>
          </div>
        </div>
      </div>
      <!-- <div>
        <button
          style="border: 0; width: 48px; height: 36px; background: #FF274F; border-radius: 5px; margin-right: 10px;"
          @click="downloadPDF"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="white"
            class="bi bi-file-earmark-pdf"
            viewBox="0 0 16 16"
          >
            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
            <path d="M4.603 14.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.697 19.697 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.712 5.712 0 0 1-.911-.95 11.651 11.651 0 0 0-1.997.406 11.307 11.307 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.266.266 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.71 12.71 0 0 1 1.01-.193 11.744 11.744 0 0 1-.51-.858 20.801 20.801 0 0 1-.5 1.05zm2.446.45c.15.163.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.876 3.876 0 0 0-.612-.053zM8.078 7.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z" />
          </svg>
        </button>
      </div> -->
    </div>
    <div style="width: 100%;padding-top: 16px; margin-top: 0px;">
      <table
        class="team_table"
      >
        <thead>
          <tr>
            <th>
              {{ $t("No") }}
            </th>
            <th>
              {{ $t('OrderNumber') }}
            </th>
            <th>
              {{ $t('OrderType') }}
            </th>
            <th>
              {{ $t('FullName') }}
            </th>
            <th>
              {{ $t('OrderState') }}
            </th>
            <!-- <th style="padding: 10px; border-radius: 0px 0px 0px 0px">
              {{ $t('ShippingCountry') }}
            </th> -->
            <th>
              {{ $t('Created') }}
            </th>
            <th />
            <th>
              {{ $t("Edit") }}
            </th>
          </tr>
        </thead>
        <tbody v-if="getAdminOrders.length > 0">
          <tr
            v-for="(order, index) in getAdminOrders"
            :key="order.id"
            class="hover-row"
            :style="classNameCh === order.orderNumber ? 'background-color: rgba(255, 39, 79, 0.1)' : ''"
            @click="matProps(order)"
          >
            <td>
              {{ getTotalItemsForOrders - (page - 1) * pageSize - index }}.
            </td>
            <td>
              {{ order.orderNumber }}
            </td>
            <td v-if="order.orderType == 'InStore'">
              {{ $t("InStore") }}
            </td>
            <td v-else-if="order.orderType == 'WholeSale'">
              {{ $t("WholeSale") }}
            </td>
            <td v-else>
              {{ order.orderType }}
            </td>
            <td>
              {{ order.clientName }}
            </td>
            <td>
              {{ $t(order.orderState) }}
            </td>
            <td>
              {{ convertUTCDateToLoacalDate(order.created) }}
            </td>
            <td />
            <td
              v-b-modal.modal-edit-order
              style="padding: 9px"
              @click="getOrder(order.orderNumber); orderNumberr(order.orderNumber, order.orderId); OrderTypes(order),loadOrderImages(order.orderId);"
            >
              <button
                class="editButton"
              >
                {{ $t('Edit') }}
              </button>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td
              colspan="6"
            >
              {{ $t('NoOrderWasFound') }}!
            </td>
          </tr>
        </tbody>
      </table>
      <div>
        <b-pagination
          v-if="getTotalItemsForOrders > 15"
          v-model="page"
          :total-rows="getTotalItemsForOrders"
          :per-page="pageSize"
          first-number
          last-number
          align="fill"
          size="md"
          prev-class="prev-item"
          next-class="next-item"
          class="mt-1 mb-0"
        >
          <template #prev-text>
            <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
          </template>
          <template #next-text>
            <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
          </template>
        </b-pagination>
      </div>
    </div>
    <AddDressModal @materials="materialsData" />
    <EditMaterialAdmin
      :order-number="orderNAme"
      :order-id="orderId"
      :client-data="clientData"
      @editOrderrr="editOrderr"
    />
    <vue-easy-lightbox
      :esc-disabled="false"
      :visible="image.visible"
      :imgs="image.imgs"
      @hide="handleHide"
    />
  </div>
</template>

<script>

// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line import/named
import AddDressModal from '@/components/products/modals/AddDressModal.vue'
import { mapActions, mapGetters } from 'vuex';
import VueEasyLightbox from 'vue-easy-lightbox'
import moment from 'moment';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
// import router from '@/router/index';
import EditMaterialAdmin from '../orders/modals/EditMaterialAdmin.vue'
// import Spinner from '../Spinner/Spinner.vue';
// import jsPDF from 'jspdf';
// import 'jspdf-autotable';
// import FileSaver from 'file-saver';


export default {
  components: {
    AddDressModal,
    EditMaterialAdmin,
    VueEasyLightbox,
    // Spinner,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['createOrder'],
  data() {
    return {
      image: {
        zoom: 1,
        imgs: [], // Img Url , string or Array of string
        visible: false,
        index: 0, //
      },
      noSearchTwo: false,
      clientId: null,
      clientData: null,
      toggleSarch: 'CustomerName',
      noSearchThree: false,
      searchShip: '',
      show: true,
      searchCN: '',
      initialId: '',
      materialPropId: '',
      status: true,
      searchOrder: '',
      orderNAme: null,
      orderId: null,
      noSearch: false,
      classNameCh: '',
      rows: {
        items: [],
      },
      materialObject: {},
      editMat: {},
      page: 1,
      pageSize: 15,
      arrowCounter: 0,
      enterPressed: false,
    }
  },
  computed: {
    ...mapGetters(['getLanguage', 'getCreateOrdersPDF', 'getLoggedInUser', 'getOrderTypes', 'getCreatedOrders', 'getTotalItemsForOrderN', 'getCurrentPageForCreatedOrders', 'getIsLoading', 'getFilteredOrdersbyON', 'getFilteredOrdersbyCN', 'getTotalItemsForOrders', 'getFilteredOrdersbyON', 'getFilteredOrdersbyCN', 'getArticleOrders', 'getAdminOrders', 'getFilteredOrdersByShipment']),
  },
  watch: {
    // eslint-disable-next-line func-names
    initialId() {
      this.immediateId(this.initialId)
    },
    page(value) {
      if (this.searchCN != null) {
        this.adminOrdersOverview({
          pageNumber: value,
          pageSize: this.pageSize,
          orderNumber: null,
          clientId: this.clientId,
          orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
          orderState: null,
          salesType: 'Material',
        })
      } else if (this.searchOrder != null) {
        this.adminOrdersOverview({
          pageNumber: value,
          pageSize: this.pageSize,
          orderNumber: this.searchOrder,
          clientId: null,
          orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
          orderState: null,
          salesType: 'Material',

        })
      } else {
        this.adminOrdersOverview({
          pageNumber: value,
          pageSize: this.pageSize,
          orderNumber: null,
          clientId: null,
          orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
          salesType: 'Material',
          orderState: null,
        })
      }
    },
    searchOrder(value) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value == '') {
          this.noSearch = false
          this.removeLists()
          this.adminOrdersOverview({
            pageNumber: this.page,
            pageSize: this.pageSize,
            orderNumber: null,
            clientId: null,
            orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
            salesType: 'Material',
            orderState: null,
          })
        } else if (this.enterPressed) {
        // eslint-disable-next-line no-useless-return
          return;
        } else {
          this.searchByOrderNumber({ orderNumber: value, salesType: 'Material' });
          this.noSearch = true
        }
      }, 500);
    },
    searchCN(value) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value == '') {
          this.clientId = null
          this.noSearchTwo = false
          this.adminOrdersOverview({
            pageNumber: this.page,
            pageSize: this.pageSize,
            orderNumber: null,
            clientId: null,
            orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
            salesType: 'Material',
            orderState: null,
          })
        } else if (this.enterPressed) {
        // eslint-disable-next-line no-useless-return
          return
        } else {
          this.searchByCustomerName(value);
          this.noSearchTwo = true
        }
      }, 500);
    },
    searchShip(value) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value == '') {
          this.adminOrdersOverview({
            pageNumber: this.page,
            pageSize: this.pageSize,
            orderNumber: null,
            clientId: null,
            orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
            salesType: 'Material',
            orderState: null,
          })
        } else if (this.enterPressed) {
        // eslint-disable-next-line no-useless-return
          return
        } else {
          this.searchByShipmentCode(value);
          this.noSearchThree = true
        }
      }, 500);
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    ...mapActions(['getFileByOrderNumber', 'accountDetails', 'shipmentByOrders', 'loadCreatedOredersPDF', 'loadCreatedOreders', 'loadCreatedOrdersByOrderNumber', 'changeLoadingtoTrue', 'resetSearchInNewOrders', 'searchInNewOrders', 'orderByOrderNumber', 'editOrdersAdmin', 'loadOrderTypes', 'firstNames', 'getOrdersOverview', 'searchByCustomerName', 'searchByOrderNumber', 'readOrderItems', 'adminOrdersOverview', 'searchByShipmentCode']),
    async fetch() {
      try {
        // const orderNumberFromQuery = this.$route.query.orderNumber;
        await this.adminOrdersOverview({
          pageNumber: this.page,
          pageSize: this.pageSize,
          orderNumber: null,
          clientId: null,
          orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
          salesType: 'Material',
          orderState: null,
        })
          .then((res) => {
            console.log(res);
            this.changeLoadingtoTrue(true)
          })
      } catch (e) {
        console.log(e);
      }
    },
    async loadOrderImages(value) {
      this.$store.commit('SET_IMAGES_ORDER', [{
        fileDataId: 'aaf153a4-be48-ee11-abf3-124abb807f69',
        mainDressColorId: 'e2b146ea-a7e9-4584-ee19-08dba4a55447',
        url: '',
        fileName: '1693569414176-createordermodal.png',
      }]);
      await this.getFileByOrderNumber(value);
      this.image.imgs = []
      for (let i = 0; i < this.getimagesOrder.length; i++) {
        const image = this.getimagesOrder[i]
        this.image.imgs.push({
          src: image.url,
          title: image.fileName,
          fileDataId: image.fileDataId,
          fileName: image.fileName,
          fileType: image.fileType,
        })
      }
    },
    showPhoto() {
      this.image.visible = true
    },
    handleHide() {
      this.image.visible = false
    },
    downloadPDF() {
      // this.changeLoadingtoTrue(false);

      // axios
      //   .get('https://logisticstoredata.digitwebsite.ch/api/v1/extendedStoresByPagination?PageNumber=1&PageSize=12')
      const orderNumberFromQuery = this.$route.query.orderNumber;
      this.loadCreatedOredersPDF({
        pageNumber: this.page,
        pageSize: 50,
        orderNumber: orderNumberFromQuery || null,
      })
        .then(() => {
          // const data = response.data;
          // const items = data.items;

          const tableContent = this.generateTableContent(this.getCreateOrdersPDF.items);

          const totalPages = this.getCreateOrdersPDF.totalPages;
          const additionalPromises = [];
          for (let pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
            additionalPromises.push(this.downloadPage(pageNumber));
          }

          Promise.all(additionalPromises).then((additionalTableContents) => {
            additionalTableContents.forEach((additionalTableContent) => {
              tableContent.body.push(...additionalTableContent.body);
            });

            const footerIcon = 'data:image/png;base64,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'

            const pdfDocument = this.generatePDF(tableContent, footerIcon);
            pdfDocument.save('Orders.pdf');
          });
          // this.changeLoadingtoTrue(true);
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
          // this.changeLoadingtoTrue(false);
        });
    },
    downloadPage(pageNumber) {
      // axios
      //   .get(
      //     `https://logisticstoredata.digitwebsite.ch/api/v1/extendedStoresByPagination?PageNumber=${pageNumber}&PageSize=12`,
      //   )
      // this.changeLoadingtoTrue(false);

      const orderNumberFromQuery = this.$route.query.orderNumber;
      return this.loadCreatedOredersPDF({
        pageNumber,
        pageSize: 50,
        orderNumber: orderNumberFromQuery || this.searchOrder,
      })

        .then(() => {
          // const data = response.data;
          // const items = data.items;
          // this.changeLoadingtoTrue(true);

          return this.generateTableContent(this.getCreateOrdersPDF.items);
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
          // this.changeLoadingtoTrue(false);
        });
    },
    generateTableContent(items) {
      // const headers = [`${this.$t('FilialeName')}`, 'GLN', 'Email', 'Phone', 'Street', 'City', 'Country', 'Trucks', 'Manager', 'TeamLeader', 'Co-TeamLeader'];
      const headers = [`${this.$t('OrderNumber')}`, `${this.$t('OrderType')}`,
        `${this.$t('CustomerName')}`, `${this.$t('BillingCountry')}`,
        `${this.$t('ShippingCountry')}`, `${this.$t('Created')}`];
      const body = items.map((item) => {
        return [
          item.orderNumber,
          item.orderType,
          item.customerName,
          item.billingAddressCountry,
          item.shippingAddressCountry,
          this.dateFormat(item.created),
        ]
      });

      return { headers, body };
    },
    // generatePDF(tableContent) {
    //   const { headers, body } = tableContent;

    //   // eslint-disable-next-line new-cap
    //   const doc = new jsPDF();
    //   doc.autoTable({
    //     head: [headers],
    //     body,
    //   });

    //   return doc;
    // },
    generatePDF(tableContent) {
      const { headers, body } = tableContent;

      // eslint-disable-next-line new-cap
      const doc = new jsPDF();

      // Add the logo to the top left corner of the first page
      // const iconWidth = 30; // Adjust the width of the icon as needed
      // const iconHeight = 10; // Adjust the height of the icon as needed
      // const iconX = 15; // Adjust the horizontal position of the icon (left)
      // const iconY = 5; // Adjust the vertical position of the icon (top)
      // doc.addImage(footerIcon, 'PNG', iconX, iconY, iconWidth, iconHeight);

      const currentTime = moment().format('DD-MM-YYYY, HH:mm:ss');
      const timeX = doc.internal.pageSize.getWidth() / (10 / 9);
      const timeY = 10;
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(currentTime, timeX, timeY, { align: 'right' });

      // Add the title
      const title = this.$t('Orders');
      const titleX = doc.internal.pageSize.getWidth() / 2;
      const titleY = 20; // Adjust the vertical position of the title
      doc.setFontSize(18);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(title, titleX, titleY, { align: 'center' });

      // Add the author
      const authorX = 15;
      const authorY = 30; // Adjust the vertical position of the author
      const author = `${this.getLoggedInUser.firstName} ${this.getLoggedInUser.lastName}`;
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(`${this.$t('Author')}: ${author}`, authorX, authorY);

      // Add the table
      const tableOptions = {
        startY: authorY + 5, // Adjust the vertical position of the table
        time: moment().format('DD-MM-YYYY'),
        head: [headers],
        body,
      };
      doc.autoTable(tableOptions);

      // const iconWidthh = 30; // Adjust the width of the icon as needed
      // const iconHeightt = 10; // Adjust the height of the icon as needed
      // // const iconX = doc.internal.pageSize.getWidth() / 2 - iconWidth / 2;
      // // const iconY = doc.internal.pageSize.getHeight() - 35; // Adjust the vertical position of the icon
      // const iconXX = doc.internal.pageSize.getWidth() / 2 - iconWidth / 2;
      // const iconYY = doc.internal.pageSize.getHeight() - 18; // Adjust the vertical position of the icon

      // doc.addImage(footerIcon, 'PNG', iconXX, iconYY, iconWidthh, iconHeightt);

      // Add a horizontal line
      const hrLineY = doc.internal.pageSize.getHeight() - 20;
      const hrLineX1 = 50;
      const hrLineX2 = doc.internal.pageSize.getWidth() - 50;
      doc.setLineWidth(0.5); // Adjust the line thickness as needed
      doc.line(hrLineX1, hrLineY, hrLineX2, hrLineY);

      // Add the address
      // const address = 'Bahnhofstrasse 276, 4563 Gerlafingen, Switzerland';
      // const addressX = doc.internal.pageSize.getWidth() / 2;
      // const addressY = doc.internal.pageSize.getHeight() - 2;
      // doc.setFontSize(8);
      // doc.setTextColor(0, 0, 0); // Black color
      // doc.text(address, addressX, addressY, { align: 'center' });

      return doc;
    },
    editOrderr(value) {
      this.editOrdersAdmin({
        clientId: value.clientId,
        obj: value,
        successCallback: () => {
          this.adminOrdersOverview({
            pageNumber: this.page,
            pageSize: this.pageSize,
            orderNumber: null,
            clientId: null,
            orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
            salesType: 'Material',
            orderState: null,
          })
          this.getFileByOrderNumber(this.orderId)
        },
      })
    },
    OrderTypes(value) {
      this.clientData = {
        name: value.clientName,
        clientId: value.clientId,
      }
      if (this.getOrderTypes.length == 0) {
        this.loadOrderTypes()
      }
    },
    async searchByOn(value) {
      this.searchOrder = value
      this.noSearch = false
      // await this.loadCreatedOreders({
      //   pageNumber: this.page,
      //   pageSize: this.pageSize,
      //   orderNumber: this.searchOrder,
      // })
      await this.adminOrdersOverview({
        pageNumber: this.page,
        pageSize: this.pageSize,
        orderNumber: this.searchOrder,
        clientId: null,
        orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
        salesType: 'Material',
        orderState: null,
      })
      // router.push({ name: 'Orders Management', query: { orderNumber: value } });
    },
    async searchByCn(value) {
      this.searchCN = value.nameToDisplay
      this.clientId = value.clientId
      this.noSearchTwo = false
      // await this.loadCreatedOreders({
      //   pageNumber: this.page,
      //   pageSize: this.pageSize,
      //   orderNumber: null,
      //   clientId: value.clientId,
      // })
      await this.adminOrdersOverview({
        pageNumber: this.page,
        pageSize: this.pageSize,
        orderNumber: null,
        clientId: value.clientId,
        orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
        salesType: 'Material',
        orderState: null,
      })
    },
    async searchByShip(value) {
      this.searchShip = value.notes
      this.notes = value.notes
      this.noSearchThree = false
      await this.adminOrdersOverview({
        pageNumber: this.page,
        pageSize: this.pageSize,
        salesType: 'Material',
        orderNumber: null,
        clientId: value.clientId,
        orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
        orderState: null,
        orderId: value.orderId,
      })
    },
    orderNumberr(orderNumber, orderId) {
      this.orderNAme = orderNumber;
      this.orderId = orderId;
      this.shipmentByOrders({
        orderId,
      })
    },
    convertUTCDateToLoacalDate(date) {
      const local = moment.utc(date).local().format('DD-MMM-YYYY h:mm A')
      return local
    },
    editMaterial(item) {
      this.editMat = item
      this.$bvModal.show('modal-edit-dress')
    },
    materialsData(obj) {
      this.materialObject = obj
      this.addMaterialItem()
    },

    async loadMore() {
      if ((this.$refs.matsListing.offsetHeight + this.$refs.matsListing.scrollTop) + 2 >= this.$refs.matsListing.scrollHeight) {
        await this.fetchCreatedOrders(this.rows.currentPage + 1)
      }
    },
    getOrder(value) {
      this.orderByOrderNumber({
        orderNumber: value,
      })
      this.accountDetails({
        isActive: true,
      })
    },
    matProps(ordNId) {
      this.$emit('sendON', ordNId.orderNumber)
      this.classNameCh = ordNId.orderNumber
      this.$emit('sendOrderState', ordNId.orderState)
      this.readOrderItems({
        orderNumber: ordNId.orderNumber,
        orderItemState: this.selectedOrderState == null ? null : this.selectedOrderState,
      })
    },
    removeLists() {
      this.noSearch = false;
      this.resetSearchInNewOrders();
    },
    onArrowDown(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.getFilteredOrdersbyON.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },

    onArrowUp(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling()
      }
    },
    dateFormat(value) {
      return moment(value).format('DD-MM-YYYY, HH:mm')
    },
    onArrowDown1(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.getFilteredOrdersbyCN.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },
    onArrowUp1(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling()
      }
    },
    onArrowDown3(ev) {
      ev.preventDefault()
      if (this.arrowCounter3 < this.getFilteredOrdersByShipment.length - 1) {
        this.arrowCounter3 += 1;
        this.fixScrolling();
      }
    },

    onArrowUp3(ev) {
      ev.preventDefault()
      if (this.arrowCounter3 > 0) {
        this.arrowCounter3 -= 1;
        this.fixScrolling()
      }
    },
    inputChanged1(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }
      // this.getFilteredOrdersbyON = [];

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByCn(this.getFilteredOrdersbyCN[this.arrowCounter])
        this.removeLists()
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    showCustomerName() {
      this.toggleSarch = 'CustomerName';
      this.searchCN = '';
      this.show = true
      this.adminOrdersOverview({
        pageNumber: this.page,
        pageSize: this.pageSize,
        salesType: 'Material',
        orderNumber: null,
        clientId: null,
        orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
        orderState: null,
      })
    },
    showOrderNumber() {
      this.toggleSarch = 'OrderNumber';
      this.searchOrder = '';
      this.show = false;
      this.adminOrdersOverview({
        pageNumber: this.page,
        pageSize: this.pageSize,
        salesType: 'Material',
        orderNumber: null,
        clientId: null,
        orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
        orderState: null,
      })
    },
    showShippingNotes() {
      this.toggleSarch = 'ShippingNotes';
      this.searchShip = ''
      this.show = false
      this.adminOrdersOverview({
        pageNumber: this.page,
        pageSize: this.pageSize,
        salesType: 'Material',
        orderNumber: null,
        clientId: null,
        orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
        orderState: null,
      })
    },
    inputChanged(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }
      // this.getFilteredActiveUsers = [];

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByOn(this.getFilteredOrdersbyON[this.arrowCounter])
        this.removeLists()
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    inputChanged3(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }
      // this.getFilteredOrdersbyON = [];

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByShip(this.getFilteredOrdersByShipment[this.arrowCounter3])
        this.removeLists()
        this.arrowCounter3 = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    fixScrolling() {
      const liH = this.$refs.options[this.arrowCounter].clientHeight;
      console.log(liH)
      this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter;
    },
  },
}
</script>

<style scoped lang="scss">
.editButton {
  height: 30px;
}

.team_table td {
  padding: 16px 9px !important;
}

.active2 {
  font-weight: bold;
  color: $base-color;
}
.active2{
  color: $base-color;
  font-weight: bold;
}
.hover-row:hover {
    background-color: rgba(255, 39, 79, 0.1);
}
.mats-listing__wrapper {
  .mats-listing{
    margin-top: 0
  }
}
  .button {
    margin-bottom: 15px!important;
  }
  .mat {
    display: flex;
    justify-content: space-between;
    align-content: center;
    &.active {
      background-color: #e8e8e8;
    }
    div {
      display: flex;
      justify-content: space-between;
      align-content: center;
    }
    span {
      margin-left: 10px;
      svg {
        font-size: 15px;
      }
    }
  }

tr:last-child {
  border-bottom: none !important;
}

table:hover {
  cursor: pointer;
}
.dropdrop::-webkit-scrollbar {
display: none;

}
.dropdrop {
display: inline-block;
overflow: auto;
position: absolute;
background: white;
width: 227px;
box-shadow: none;
}

input[name="search-box"] {
  display: block;
  max-width: 500px;
  width: 95%;
  padding: 0.5rem 1rem;
  padding-left: 25px;
}
.search-item {
  padding: 5px;
  max-width: 500px;
  width: 100%;
  font-weight: 400;
  color: #82868c;
  font-size: 1rem;
  border-bottom: 1px solid #e8e8e8;
}
.search-item:last-child {
  border-bottom: none;
}
.search-item:hover {
  background: #82868c;
  color: white;
}
.search-item hr {
  color: lightgray;
  border-top: none;
  margin: -1.3rem 0 0.5rem 0;
}
.is-active {
  background-color: #dedede;
}
</style>
